import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onExport, onDelete, onUpdateStatus, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-card border border-border rounded-lg shadow-xl p-4 min-w-[320px] md:min-w-[480px]">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? 'proyecto seleccionado' : 'proyectos seleccionados'}
            </p>
            <button
              onClick={onClearSelection}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors duration-250"
            >
              Limpiar selección
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onUpdateStatus}
            iconName="Edit"
            iconSize={16}
            title="Actualizar estado"
          />
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconSize={16}
            title="Exportar selección"
          />
          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
            iconName="Trash2"
            iconSize={16}
            title="Eliminar selección"
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;